import React from 'react';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  text: {
    background: '#EEE',
    color: theme.palette.getContrastText('#EEE'),
    padding: '5px 10px',
  }
}))


function PeriodHeader({ period }) {
  const classes = useStyles();
  
  return (
    <Typography className={classes.text}>{period}</Typography>
  )
}

export default PeriodHeader;
